import {
  getAccountHoldersList,
  GetAccountHoldersListBody,
  GetAccountHoldersListResponse,
} from "../../../services/accountService";
import { useQuery, UseQueryOptions } from "@tanstack/react-query";

export default function useAccountHoldersQuery(
  params: GetAccountHoldersListBody,
  queryOptions?: UseQueryOptions<GetAccountHoldersListResponse, string>
) {
  return useQuery<GetAccountHoldersListResponse, string>(
    ["accountHolders", params],
    () => getAccountHoldersList(params),
    {
      ...queryOptions,
    }
  );
}
